import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard/Dashboard";
import MyCharts from "./components/Dashboard/MyCharts";
import SignIn from "./components/SignIn/SignIn";
import Bookings from "./components/Bookings/Bookings";
import Calendar from "./components/Calendar/Calendar";
import Properties from "./components/Properties/Properties";
import AddPropertyElementor from "./components/Properties/AddPropertyElementor";
import AddPropertyDetailElementor from "./components/PropertiesNew/AddPropertyDetailElementor";
import EditPropertyElementor from "./components/Properties/EditPropertyElementor";
import EditPropertyDetailElementor from "./components/PropertiesNew/EditPropertyDetailElementor";
import GuestRecords from "./components/GuestRecords/GuestRecords";
import StaffManagement from "./components/StaffManagement/StaffManagement";
import Payments from "./components/Payments/Payments";
import InvoicePDF from "./components/Payments/InvoicePDF";
import Reviews from "./components/Reviews/Reviews";
import Discounts from "./components/Discounts/Discounts";
import KanbanBoard from "./components/KanbanBoard/KanbanBoard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./components/ProtectedRoute";
import { Navigate } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import AddHotelElementor from "./components/Properties/AddHotelElementor";
import EditHotelElementor from "./components/Properties/EditHotelElementor";
import BlogElementor from "./components/BlogElementor/BlogElementor";
import FeedbackForm from "./components/Reviews/FeedbackForm";
import QuickBrochure from "./components/Properties/QuickBrochure";
import ChannelLeads from "./components/Bookings/ChannelLeads";
import BrochureElementor from "./components/PropertyBrochure/BrochureElementor";
import BrochurePDF from "./components/PropertyBrochure/BrochurePDF";
import PropertyBrochure from "./components/PropertyBrochure/PropertyBrochure";
import HotelBrochureElementor from "./components/PropertyBrochure/HotelBrochureElementor";
import HotelBrochurePdf from "./components/PropertyBrochure/HotelBrochurePdf";
import EditBrochureElementor from "./components/PropertyBrochure/EditBrochureElementor";
import PropertyScraperElementor from "./components/Properties/PropertyScraperElementor";
import SmartScheduler from "./components/SmartScheduler/SmartScheduler";
import InquireLeads from "./components/Bookings/InquireLeads";
import PreBookingPDF from "./components/Bookings/Prebookingpdf";
import Bookingconfirmpdf from "./components/Bookings/Bookingconfirmpdf";
import CashbackElementore from "./components/Bills/CashbackElementore";
import InvoiceElementore from "./components/Bills/InvoiceElementore";
import Bills from "./components/Bills/Bills";
import InvoiceEdit from "./components/Bills/InvoiceEdit";
import InvoiceView from "./components/Bills/InvoiceView";
import CashbackEdit from "./components/Bills/CashbackEdit";
import CashbackView from "./components/Bills/CashbackView";
import TestAddPropertyDetailElementor from "./components/PropertiesNew/TestAddPropertyDetailElementor";
import TestEditPropertyDetailElementor from "./components/PropertiesNew/TestEditPropertyDetailElementor";
import Loader from "./components/Loader/Loader";
import PreLeadPDF from "./components/Bookings/PreLeadPDF";
import PreWebsiteLeadPDF from "./components/Bookings/PreWebsiteLeadPDF";
import NewQuickBrochure from "./components/Properties/NewQuickBrochure";
import BannerElementor from "./components/BannerElementor/BannerElementor";

function App() {
  return (
    <div>
      <Router>
        <ToastContainer position="top-right" autoClose={3000} />

        <Routes>
          <Route path="/" element={<Navigate to="/SignIn" replace />} />

          <Route path="/SignIn" element={<SignIn />} />

          <Route
            path="/BrochureElementor"
            element={
              <ProtectedRoute>
                <BrochureElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/EditBrochureElementor/:id"
            element={
              <ProtectedRoute>
                <EditBrochureElementor />
              </ProtectedRoute>
            }
          />
          {/* <Route path="/BrochurePDF" element={<BrochurePDF />} /> */}
          <Route
            path="/BrochurePDF/:id"
            element={
              <ProtectedRoute>
                <BrochurePDF />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ChannelLeads"
            element={
              <ProtectedRoute>
                <ChannelLeads />
              </ProtectedRoute>
            }
          />

          {/* Protected routes */}
          <Route
            path="/Dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Bookings"
            element={
              <ProtectedRoute>
                <Bookings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Calendar"
            element={
              <ProtectedRoute>
                <Calendar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Properties"
            element={
              <ProtectedRoute>
                <Properties />
              </ProtectedRoute>
            }
          />
          <Route
            path="/QuickBrochure/:propertyid"
            element={
              <ProtectedRoute>
                <QuickBrochure />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/NewQuickBrochure"
            element={
              <ProtectedRoute>
                <NewQuickBrochure />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/NewQuickBrochure/:propertyid"
            element={
              <ProtectedRoute>
                <NewQuickBrochure />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddPropertyElementor"
            element={
              <ProtectedRoute>
                <AddPropertyElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddPropertyDetailElementor"
            element={
              <ProtectedRoute>
                <AddPropertyDetailElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PropertyScraperElementor"
            element={
              <ProtectedRoute>
                <PropertyScraperElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddHotelElementor"
            element={
              <ProtectedRoute>
                <AddHotelElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/EditPropertyElementor"
            element={
              <ProtectedRoute>
                <EditPropertyElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/EditPropertyDetailElementor"
            element={
              <ProtectedRoute>
                <EditPropertyDetailElementor />
              </ProtectedRoute>
            }
          />

          <Route
            path="/TestAddPropertyDetailElementor"
            element={
              <ProtectedRoute>
                <TestAddPropertyDetailElementor />
              </ProtectedRoute>
            }
          />

          <Route
            path="/TestEditPropertyDetailElementor"
            element={
              <ProtectedRoute>
                <TestEditPropertyDetailElementor />
              </ProtectedRoute>
            }
          />

          <Route
            path="/EditHotelElementor"
            element={
              <ProtectedRoute>
                <EditHotelElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/GuestRecords"
            element={
              <ProtectedRoute>
                <GuestRecords />
              </ProtectedRoute>
            }
          />
          <Route
            path="/StaffManagement"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <StaffManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Payments"
            element={
              // <ProtectedRoute>
              <Payments />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/Bills"
            element={
              // <ProtectedRoute>
              <Bills />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/invoice/:bookingid"
            element={
              <ProtectedRoute>
                <InvoicePDF />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Reviews"
            element={
              <ProtectedRoute>
                <Reviews />
              </ProtectedRoute>
            }
          />
          <Route
            path="/KanbanBoard"
            element={
              <ProtectedRoute>
                <KanbanBoard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Discounts"
            element={
              <ProtectedRoute>
                <Discounts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PropertyBrochure"
            element={
              <ProtectedRoute>
                <PropertyBrochure />
              </ProtectedRoute>
            }
          />
          <Route
            path="/HotelBrochureElementor"
            element={
              <ProtectedRoute>
                <HotelBrochureElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/HotelBrochurePdf"
            element={
              <ProtectedRoute>
                <HotelBrochurePdf />
              </ProtectedRoute>
            }
          />
          <Route
            path="/FeedbackForm/:bookingid"
            element={
              <ProtectedRoute>
                <FeedbackForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/BlogElementor"
            element={
              <ProtectedRoute>
                <BlogElementor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MyCharts"
            element={
              <ProtectedRoute>
                <MyCharts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SmartScheduler"
            element={
              <ProtectedRoute>
                <SmartScheduler />
              </ProtectedRoute>
            }
          />
          <Route
            path="/InquireLeads"
            element={
              <ProtectedRoute>
                <InquireLeads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddCashBackBill"
            element={
              <ProtectedRoute>
                <CashbackElementore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddInvoiceBill"
            element={
              <ProtectedRoute>
                <InvoiceElementore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoice/:invoiceid/edit"
            element={
              <ProtectedRoute>
                <InvoiceEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoice-view/:invoiceid"
            element={
              <ProtectedRoute>
                <InvoiceView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cashback/:invoiceid/edit"
            element={
              <ProtectedRoute>
                <CashbackEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cashback-view/:invoiceid"
            element={
              <ProtectedRoute>
                <CashbackView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prebookingpdf/:id"
            element={
              <ProtectedRoute>
                <PreBookingPDF />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookingconfirmpdf/:id"
            element={
              <ProtectedRoute>
                <Bookingconfirmpdf />
              </ProtectedRoute>
            }
          />

          <Route
            path="/BannerElementor"
            element={
              <ProtectedRoute>
                <BannerElementor />
              </ProtectedRoute>
            }
          />
          <Route path="/loader" element={<Loader />} />
          <Route path="/preleadpdf/:id" element={<PreLeadPDF />} />
          <Route
            path="/prewebsiteleadpdf/:id"
            element={<PreWebsiteLeadPDF />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
